import React, { useState, useEffect } from 'react';
import './CookieConsentBanner.css';
import { useTranslation } from 'react-i18next';

// Chave para armazenar o status no localStorage
const CONSENT_KEY = 'top5_cookie_consent';

function CookieConsentBanner({ onAccept, onReject, onReadPolicy }) {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Verifica se o consentimento já foi dado
    const consentStatus = localStorage.getItem(CONSENT_KEY);
    
    // Se não houver status salvo, exibe o banner
    if (consentStatus === null) {
      setShowBanner(true);
    } else if (consentStatus === 'accepted') {
      // Se já aceito, chama a função de aceitação imediatamente (para carregar Analytics)
      onAccept();
    }
  }, [onAccept]);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setShowBanner(false);
    onAccept();
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setShowBanner(false);
    onReject();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner-content">
        <p className="cookie-message">
          {t('cookie_message', { privacy_link: t('privacy_policy') })}
        </p>
        <div className="cookie-buttons">
          <button className="reject-button" onClick={handleReject}>
            {t('cookie_reject')}
          </button>
          <button className="accept-button" onClick={handleAccept}>
            {t('cookie_accept')}
          </button>
        </div>
        <button
          type="button"
          className="cookie-policy-link"
          onClick={onReadPolicy}
        >
          {t('cookie_read_policy')}
        </button>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
